module.exports = __webpack_public_path__ + "img/ref-active.8fbf07b4.svg";